var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 0.75px;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.12,22.5H2.89c-.15,0-.15,0-.15-.14,0-.49,0-1,0-1.47a9.15,9.15,0,0,1,.77-3.53,9.25,9.25,0,0,1,5-4.88l.3-.12a.22.22,0,0,1,.22,0,6.48,6.48,0,0,0,1.42.5,6.66,6.66,0,0,0,1.33.19,7.18,7.18,0,0,0,2.83-.4,6.59,6.59,0,0,0,.73-.3.16.16,0,0,1,.15,0,9.28,9.28,0,0,1,2.69,1.56,9.52,9.52,0,0,1,2.3,2.83,9.26,9.26,0,0,1,1,3.2,9.6,9.6,0,0,1,.08,1.31c0,.38,0,.76,0,1.13,0,.13,0,.13-.12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.13.89A6.07,6.07,0,1,1,6.05,7,6.06,6.06,0,0,1,12.13.89Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser01);
export default __webpack_public_path__ + "static/media/user_01.0df52a2d0010691866ebb9c7926885cb.svg";
export { ForwardRef as ReactComponent };